import { type Meta } from '../types/docs';

const META: Meta = {
  // renamed from viewed_collection, 2026-08-17 (param collection_id renamed to showcase_id)
  description: 'Customer opens a showcase from the showcases list.',
  name: 'viewed_showcase',
  params: [
    {
      description: 'Showcase ID',
      name: 'showcase_id',
      required: true,
      type: 'string',
    },
    {
      description: 'Short URL ID',
      name: 'short_url_id',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
